import React from 'react';
import ErrorMessage from '../ErrorMessage';

class OverWindow extends React.Component {
  static defaultProps = {
    clickOnCancel: () => {
      alert('Define prop: clickOnCancel');
    },
    title: 'Default Title',
    eyebrow: null,
    idPill: null,
    progressPercent: null,
    children: <div className='border bg-warning'>This is the content.</div>,
    closeOnClickOutside: true,
    iconName: 'fa-solid fa-window-maximize',
    verticalScroll: true,
    maxWidth: 0,
    minHeight: 0,
    className: 'top-of-box',
    compact: false,
    shouldConfirmCancel: null,
  };

  constructor(props) {
    super(props);
    this.windowref = React.createRef();

    this.escFunction = this.escFunction.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.requestCancel = this.requestCancel.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
    if (this.props.closeOnClickOutside) {
      document.addEventListener('mousedown', this.handleClickOutside, false);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
    if (this.props.closeOnClickOutside) {
      document.removeEventListener('mousedown', this.handleClickOutside, false);
    }
  }

  // Close with the data-loss confirm, unless the host reports nothing was edited.
  // Without the shouldConfirmCancel prop the X keeps its legacy always-confirm behavior.
  requestCancel() {
    if (this.props.shouldConfirmCancel && !this.props.shouldConfirmCancel()) {
      this.props.clickOnCancel();
      return;
    }
    ErrorMessage.SetApprove(
      'If you cancel this process all entered data will be lost!',
      this.props.clickOnCancel,
      'Do you want to cancel?'
    );
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      // Hosts with a dirty-check get the same protection on Esc (legacy Esc closed
      // silently even with unsaved edits); hosts without it keep the old behavior.
      if (this.props.shouldConfirmCancel) {
        this.requestCancel();
      } else {
        this.props.clickOnCancel();
      }
    }
  }

  handleClickOutside(event) {
    if (this.props.closeOnClickOutside) {
      const node = this.windowref.current;

      if (event.target.contains(node)) {
        event.preventDefault();
        this.props.clickOnCancel();
      }
    }
  }

  render() {
    const style = this.props.minHeight !== 0 ? { minHeight: this.props.minHeight + 'px' } : {};

    return (
      <>
        <div
          className='ow-scrim'
          aria-hidden='true'
        />
        <div
          className={'EditBox bravo-ds ' + (this.props.compact ? 'compact ' : '')}
          ref={this.windowref}
          style={style}
        >
          <div className='OverWindowWrapper '>
            <span
              className='ow-head-icon'
              aria-hidden='true'
            >
              <i className={this.props.iconName} />
            </span>
            <div className='OverWindowTitleBlock'>
              {this.props.eyebrow ? <span className='OverWindowEyebrow'>{this.props.eyebrow}</span> : null}
              <h6 className='OverWindowTitle'>
                <p>{this.props.title}</p>
              </h6>
            </div>
            {this.props.idPill !== null && this.props.idPill !== '' ? (
              <span className='ow-id-pill'># {this.props.idPill}</span>
            ) : null}
            <div className='OverWindowHeaderbutton'>
              <button
                type='button'
                className='ow-close'
                title='Cancel'
                onClick={this.requestCancel}
              >
                <i className='fa-solid fa-xmark' />
              </button>
            </div>
          </div>
          {this.props.progressPercent !== null ? (
            <div className='OverWindowProgress'>
              <div
                className='OverWindowProgressFill'
                style={{ width: `${this.props.progressPercent}%` }}
              />
            </div>
          ) : null}
          <div className='OverWindowBody'>{this.props.children}</div>
        </div>
      </>
    );
  }
}

export default OverWindow;
